import { registerBlockType } from '@wordpress/blocks';

import metadata from '../block.json';
import Edit from './Edit';
import './editor.scss';

import icons from './Const/icons';

// block register 
registerBlockType(metadata, {
	icon: {
		src: icons.slider,
	},
	edit: Edit,
	save: () => null
});